export default "__VITE_ASSET__DNqqpEWf__"